export const getGoogleMapsApiKey = () => GOOGLE_MAP_KEY;
export const getAuthEndpoint = () => B2C_AUTH_ENDPOINT;
export const getTokenEndpoint = () => B2C_TOKEN_ENDPOINT;
export const getClientId = () => B2C_CLIENT_ID;
export const getLogoutEndpoint = () => B2C_LOGOUT_ENDPOINT;
export const getLogoutRedirect = () => B2C_LOGOUT_REDIRECT;
export const getAppEnv = () => APP_ENV;
export const isMockSever = () => MOCK_SERVER;
